import React from "react";
import CollegePageContainer from "../../Container/CollegePageContainer";
import JobListingFull from "../../../Components/JobListingFull/JobListingFull";
import CancelButton from "../../../Components/Buttons/CancelButton";
import ConfirmButton from "../../../Components/Buttons/ConfirmButton";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { API } from "../../../API";
import { notify } from "react-notify-toast";

function PostJobPreview(props) {
  // const { job, inst } = props;
  const { institution, campuses } = props;

  const job = props.location.state.listing_data;
  const type = props.location.state.type;

  const campus = campuses.find(c => c._id === job.location);

  let tabs = [
    {
      text: "My Vacancies",
      pathname: "/MyListings",
    },
    {
      text: "Job Vacancy",
      pathname: "/",
      active: true
    }
  ]

  const goBack = () => {
    let url = "";
    if (type === "edit") {
      url = "/JobListing/Edit/" + job._id
    }
    else {
      url = "/PostJobDraft"
    }
    props.history.push(url, job)
  }

  const onSubmit = () => {
    // const listing_data = getListingData(job, this.props.user, this.props.institution);
    const listing_data = { ...job }
    if (listing_data.status !== "published") {
      listing_data.status = "published"
      listing_data.pub_date = new Date()
    }
    delete listing_data.salary_type

    // if draft id already saved, update instead of create
    if (listing_data._id) {
      API.updateListing(listing_data)
        .then(res => {
          // console.log(res)
          notify.show(`Vacancy ${type === "edit" ? "updated" : "published"} successfully`)
          props.history.push(`/JobListing/${listing_data._id}`, { showSharePopup: true })
        })
        .catch(err => {
          console.log(err.response)
          notify.show("Error saving Vacancy")
        })
    }
    else {
      API.createListing(listing_data)
        .then(res => {
          // this.setState({ _id: res.data._id })
          notify.show("Vacancy published successfully")
          props.history.push(`/JobListing/${res.data._id}`, { showSharePopup: true })
        })
        .catch(err => {
          console.log(err.response)
          notify.show("Error saving vacancy")
        })
    }
  }

  // if (job.inst_id === props.institution._id && props.user.role === "customer") {
  //   tabs.push({
  //     text: "Edit Listing",
  //     pathname: "",
  //     disabled: true
  //   },
  //     {
  //       text: "View Applicants",
  //       pathname: "",
  //       disabled: true
  //     })
  // }

  return (
    <CollegePageContainer
      header="Job Board"
      tabs={tabs}
      user={props.user}
    >
      <h3 className="mb-5 center-text">This is a preview of your job vacancy.</h3>
      <JobListingFull
        job={job}
        inst={institution}
        campus={campus}
      />
      <div className="mt-5 row justify-content-center">
        <div className="col-md-3">
          <CancelButton onClick={goBack}>Go Back</CancelButton>
        </div>
        <div className="col-md-3">
          <ConfirmButton onClick={onSubmit}>Publish Vacancy</ConfirmButton>
        </div>
      </div>
    </CollegePageContainer>
  )
}

function mapStateToProps(state) {
  return {
    user: state.college.user,
    institution: state.college.institution,
    campuses: state.college.campuses
  }
}

export default connect(mapStateToProps)(withRouter(PostJobPreview));